export const brokerTitles = ['Owner', 'President', 'Managing Member', 'Principal'];
